import PropTypes from 'prop-types';
import React from 'react';

// components
import { Button } from '../../shared/_form';
import Modal from '../../shared/_Modal';
import connect from 'react-redux/es/connect/connect';
import { tooltipHide } from '../../../actions/tooltipActions';
import { appointmentStatusClear } from '../../../actions/appointmentStatusActions';

class DirectOfficeContactModal extends React.Component {
    _hideModal = () => () => {
      const { hideTooltip, id } = this.props;

      hideTooltip(id);
    };

    componentWillUnmount() {
      const { clearAppointmentStatus } = this.props;

      clearAppointmentStatus();
      this._hideModal();
    }

    render() {
      const { id } = this.props;

      return (
        <Modal id={ id }>
          <div>
              Due to the fact that the meeting has been canceled less than 24 hours, please contact the office directly.
          </div>
          <div className='modal__warning'>Failure to do so can result with blocking access!</div>
          <div className='modal__actions'>
            <Button className='form__button form__button--green' onClick={ this._hideModal() } type='button'>Close</Button>
          </div>
        </Modal>
      );
    }
}

DirectOfficeContactModal.propTypes = {
  clearAppointmentStatus: PropTypes.func,
  hideTooltip: PropTypes.func,
  id: PropTypes.string
};

const mapDispatchToProps = {
  hideTooltip: (id) => tooltipHide({ id: id }),
  clearAppointmentStatus: () => appointmentStatusClear()
};

export default connect(null, mapDispatchToProps)(DirectOfficeContactModal);



// WEBPACK FOOTER //
// ./app/components/reps/calendar/_DirectOfficeContactModal.jsx